import { render, staticRenderFns } from "./QuestionManage.vue?vue&type=template&id=5ffb0317&scoped=true"
import script from "./QuestionManage.vue?vue&type=script&lang=js"
export * from "./QuestionManage.vue?vue&type=script&lang=js"
import style0 from "./QuestionManage.vue?vue&type=style&index=0&id=5ffb0317&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffb0317",
  null
  
)

export default component.exports